export const DRAWER_WIDTH: number = 256;
export const PAGE_SIZE: number = 15;
